import { useToastStore } from '../store/useToastStore.js';

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-16 sm:bottom-4 right-4 z-[100] space-y-2 max-w-sm">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-2 rounded-lg px-4 py-3 text-sm shadow-lg ${
            toast.type === 'error'
              ? 'bg-destructive-600 text-white'
              : toast.type === 'success'
              ? 'bg-green-600 text-white'
              : 'bg-slate-800 text-white'
          }`}
        >
          <span className="flex-1">{toast.message}</span>
          <button onClick={() => removeToast(toast.id)} className="text-white/70 hover:text-white">&times;</button>
        </div>
      ))}
    </div>
  );
}
